// extracted by mini-css-extract-plugin
export default {"tx":"f70d0f0f14","line":"_3a8af1b7c6"};